export enum NewRequestMenuItemsEnum {
    clientInfo = 1,
    requestInfo = 2,
    customerObjectInfo = 3,
    contacts = 4,
    servicesAndDevices = 5,
    clientRequestHistory = 6
} 